import React, { useCallback, useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import axios from "axios";

const FileUploader = ({ onFilesChange, existingFiles = [] }) => {
  const [files, setFiles] = useState([]);
  const [serverFiles, setServerFiles] = useState([]);

  // Load server files when prop changes
  useEffect(() => {
    setServerFiles(existingFiles || []);
  }, [existingFiles]);

  // Drop new files
  const onDrop = useCallback(
    (acceptedFiles) => {
      const updatedFiles = [...files, ...acceptedFiles];
      setFiles(updatedFiles);
      if (typeof onFilesChange === "function") {
        onFilesChange(updatedFiles);
      }
    },
    [files, onFilesChange]
  );


  const removeFile = (fileName) => {
    setFiles((prev) => prev.filter((file) => file.name !== fileName));
  };

  const removeServerFile = async (file) => {
    try {
      await axios.post(`https://fpapi.finnovate.in/api/executive-summary-attachments/delete`, {
        id: file.id
      }); // adjust API endpoint
      setServerFiles((prev) => prev.filter((f) => f.id !== file.id));
    } catch (error) {
      console.error("Error deleting file", error);
    }
  };

  const getFilePreview = (file, isServer = false) => {
    const fileName = isServer ? file.file_name : file.name;
    const fileType = isServer ? file.mime_type || "" : file.type;

    if (fileType?.startsWith("image/") || /\.(jpg|jpeg|png|gif)$/i.test(fileName)) {
      return (
        <img
          src={
            isServer
              ? `https://fpapi.finnovate.in/storage/${file.file_path}`
              : URL.createObjectURL(file)
          }
          alt={fileName}
          style={{ width: "100%", height: 100, objectFit: "cover" }}
        />
      );
    }
    if (fileType === "application/pdf" || /\.pdf$/i.test(fileName)) {
      return <div className="file-icon">📄 PDF</div>;
    }
    if (
      fileType?.startsWith("text/") ||
      /\.(csv|xlsx|xls)$/i.test(fileName)
    ) {
      return <div className="file-icon">📄 {fileName.split(".").pop().toUpperCase()}</div>;
    }
    return <div className="file-icon">📁 {fileName.split(".").pop().toUpperCase()}</div>;
  };



  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "image/*": [],
      "application/pdf": [],
      "text/plain": [],
      "text/csv": [],
      "application/vnd.ms-excel": [],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
    },
    multiple: true,
  });

  return (
    <div>


      {/* New Files Upload */}
      <div {...getRootProps()} className="dropzone">
        <input {...getInputProps()} />
        {isDragActive ? (
          <p>Drop the files here ...</p>
        ) : (
          <p>Drag & drop new files here, or click to select</p>
        )}
      </div>
      <div className="file-preview-grid">
        {/* New Files Preview */}
        {files.length > 0 && (
          <>
            {
              files.map((file) => (
                <div key={file.name} className="file-item">
                  {getFilePreview(file)}
                  <p className="file-name">{file.name}</p>
                  <button
                    className="remove-btn"
                    onClick={() => removeFile(file.name)}
                  >
                    Remove
                  </button>
                </div>
              ))
            }
          </>
        )}

        {/* Existing Files */}
        {serverFiles.length > 0 && (
          <>
            {serverFiles.map((file) => (
              <div key={`server-${file.id}`} className="file-item">
                {getFilePreview(file, true)}
                <p className="file-name">{file.file_name}</p>
                <button
                  className="remove-btn"
                  onClick={() => removeServerFile(file)}
                >
                  Remove
                </button>
              </div>
            ))}
          </>
        )}

      </div>



      <style>{`
        .dropzone {
          border: 2px dashed #aaa;
          padding: 20px;
          text-align: center;
          margin-bottom: 20px;
          border-radius: 8px;
          cursor: pointer;
        }
        .file-preview-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
          gap: 16px;
          margin-top: 10px;
        }
        .file-item {
          border: 1px solid #ddd;
          padding: 10px;
          border-radius: 8px;
          text-align: center;
          background: #f9f9f9;
        }
        .file-name {
          margin: 10px 0 5px;
          font-size: 14px;
          word-break: break-word;
        }
        .remove-btn {
          background-color: #e74c3c;
          border: none;
          color: white;
          padding: 5px 10px;
          border-radius: 4px;
          cursor: pointer;
        }
        .remove-btn:hover {
          background-color: #c0392b;
        }
        .file-icon {
          font-size: 40px;
          margin-bottom: 10px;
        }
      `}</style>
    </div>
  );
};

export default FileUploader;
